module.exports = __webpack_public_path__ + "static/media/illustartion-scooter.24eb26bb.svg";